<template>
    <div class="app">
        <!--<debug></debug>-->
        <transition name="v-transition-main-views">
            <router-view v-cloak></router-view>
        </transition>
        <nks-footer></nks-footer>
    </div>
</template>

<script>
    import Footer from './components/Footer.vue';
    import Debug from './debug.vue';

    export default {
        components: {
            nksFooter: Footer,
            debug: Debug
        }
    }
</script>

<style>
</style>



// WEBPACK FOOTER //
// App.vue?7d46cddc